import CONSTANTS from '../../constants';

export function appointment(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.APPOINTMENT.CREATE:
            return action.appointment;
        case CONSTANTS.ACTIONS.APPOINTMENT.GET.APPOINTMENT:
            return action.appointment;
        case CONSTANTS.ACTIONS.APPOINTMENT.CONFIRM:
            return action.appointment;
        default:
            return state
    }
}